import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import UImage from '../../../../components/UImage';

const arrowRightIcon = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/recipe/arrow_right_gray800_24x24.svg`;

const RecipeMainBanner = () => null;

const Wrapper = ({
  children,
  onClick,
  bgColor,
}: {
  children: ReactNode;
  onClick: () => void;
  bgColor: 'bg-brand-16' | 'bg-brown-400';
}) => (
  <button
    onClick={onClick}
    className={`flex w-full items-center gap-8px rounded-10px px-20px py-24px ${bgColor}`}
    type="button"
  >
    {children}
    <UImage
      src={arrowRightIcon}
      alt="오른쪽 화살표"
      width={24}
      height={24}
      className="h-24px w-24px"
    />
  </button>
);

const Icon = (props: { src: string; alt: string }) => (
  <UImage {...props} width={36} height={36} className="h-36px w-36px" />
);

const TitleAndCaption = ({
  title,
  caption,
}: {
  title: string;
  caption: string;
}) => (
  <div className="flex grow flex-col items-start gap-8px">
    <p className="text-22px font-bold">{title}</p>
    <p className="text-14px font-medium text-gray-500">{caption}</p>
  </div>
);

RecipeMainBanner.Wrapper = Wrapper;
RecipeMainBanner.Icon = Icon;
RecipeMainBanner.TitleAndCaption = TitleAndCaption;

export default RecipeMainBanner;
